import { Component, inject } from '@angular/core';
import { AdminService } from "../../../core/services/admin.service";

@Component({
  selector: 'app-admin-matrix',
  templateUrl: './admin-matrix.component.html',
  styleUrl: './admin-matrix.component.scss'
})
export class AdminMatrixComponent {
  private readonly adminService = inject(AdminService);

  matrix: any;
  private readonly excludedRoles = ['Pending', 'Patient', 'SiteContact', 'SystemAdministrator'];
  selectedRoleId: string | null = null;

  constructor() {
    this.adminService.getMatrix().subscribe({
      next: matrix => {
        this.matrix = matrix;
      }
    })
  }

  getFilteredRoles(): any[] {
    if (!this.matrix || !this.matrix.roles) {
      return [];
    }
    
    return this.matrix.roles.filter((role: any) => 
      !this.excludedRoles.includes(role.roleName)
    );
  }

  getUniquePermissions(): string[] {
    const filteredRoles = this.getFilteredRoles();
    if (filteredRoles.length === 0) {
      return [];
    }
    
    const permissionSet = new Set<string>();
    filteredRoles.forEach((role: any) => {
      role.permissions.forEach((permission: any) => {
        permissionSet.add(permission.permissionName);
      });
    });
    
    return Array.from(permissionSet).sort();
  }

  hasPermission(role: any, permissionName: string): boolean {
    if (!role || !role.permissions) {
      return false;
    }
    
    const permission = role.permissions.find((p: any) => p.permissionName === permissionName);
    return permission ? permission.hasPermission : false;
  }

  formatRoleName(roleName: string): string {
    if (!roleName) {
      return '';
    }
    
    return roleName.replace(/([A-Z])/g, ' $1').trim();
  }

  onRoleHeaderClick(role: any): void {
    if (this.selectedRoleId === role.roleId) {
      this.selectedRoleId = null; // Untoggle if clicking the same role
    } else {
      this.selectedRoleId = role.roleId; // Toggle to new role
    }
  }

  isRoleSelected(role: any): boolean {
    return this.selectedRoleId === role.roleId;
  }

  isRoleDimmed(role: any): boolean {
    return this.selectedRoleId !== null && this.selectedRoleId !== role.roleId;
  }
}
